import { InjectionToken } from '@angular/core';

export const HIGHLIGHT_OPTIONS = new InjectionToken<HighlightOptions>(
  'HIGHLIGHT_OPTIONS'
);

export interface HighlightOptions {
  languages?: () => HighlightLanguage[];
  config?: HighlightConfig;
}

export interface HighlightLanguage {
  name: string;
  func: () => any;
}

export interface HighlightConfig {
  tabReplace?: string;
  useBR?: boolean;
  classPrefix?: string;
  languages?: string[];
}

export interface HighlightResult {
  language?: string;
  r?: number;
  second_best?: any;
  top?: any;
  value?: string;
}
